var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.2997 7.38867H14.9664V9.36666H18.2997C19.2913 9.36666 20.0604 9.87269 20.0604 10.3085V19.0799C20.0604 19.5154 19.2913 20.0221 18.2997 20.0221H5.69958C4.70828 20.0221 3.93917 19.5154 3.93917 19.0799V10.3095C3.93917 9.87368 4.70828 9.36732 5.69958 9.36732H9.03249V7.38933H5.69958C3.60324 7.38933 1.96118 8.67206 1.96118 10.3095V19.0802C1.96118 20.718 3.60324 22.0001 5.69958 22.0001H18.3003C20.396 22.0001 22.0387 20.7173 22.0387 19.0802V10.3095C22.0384 8.6714 20.3964 7.38867 18.2997 7.38867Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.9924 11.523C14.8625 11.5229 14.7339 11.5485 14.6139 11.5983C14.4939 11.6481 14.3849 11.7211 14.2932 11.8131L13.055 13.051V2.98899C13.055 2.7267 12.9508 2.47514 12.7653 2.28967C12.5799 2.1042 12.3283 2 12.066 2C11.8037 2 11.5521 2.1042 11.3667 2.28967C11.1812 2.47514 11.077 2.7267 11.077 2.98899V13.1176L9.77186 11.8128C9.68021 11.7207 9.57125 11.6476 9.45126 11.5977C9.33126 11.5478 9.20259 11.5221 9.07265 11.5221C8.9427 11.5221 8.81403 11.5478 8.69403 11.5977C8.57404 11.6476 8.46508 11.7207 8.37343 11.8128C8.28155 11.9046 8.20867 12.0135 8.15894 12.1335C8.10921 12.2534 8.08362 12.382 8.08362 12.5118C8.08362 12.6417 8.10921 12.7703 8.15894 12.8902C8.20867 13.0102 8.28155 13.1191 8.37343 13.2109L11.3262 16.1637C11.4179 16.2556 11.5269 16.3284 11.6468 16.378C11.7668 16.4276 11.8953 16.4531 12.0251 16.4528H12.04C12.2931 16.4528 12.5457 16.3569 12.7388 16.1637L15.6916 13.2109C15.8303 13.0728 15.9248 12.8965 15.9631 12.7046C16.0015 12.5127 15.982 12.3137 15.9071 12.1329C15.8322 11.9521 15.7052 11.7976 15.5424 11.689C15.3796 11.5804 15.1881 11.5227 14.9924 11.523Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpfile);
export default __webpack_public_path__ + "static/media/upfile.c8bece281db3c3a75edfca6805cc5bcd.svg";
export { ForwardRef as ReactComponent };